module.exports = __webpack_public_path__ + "static/media/female_couple.84ec0c3f.svg";